import i18n from "../../i18n";
import store from "../../store";
import { createFieldInput, createFieldInputNumber, createFieldSelect } from "../input/template-builder/template-builder.logic";
import lodash from 'lodash'
import { conditionFormChecker, putField } from "../../utils/form";

export const createFormAddress = () => {
    return {
        addrNo: null,
        addrRoom: null,
        addrBuilding: null,
        addrFloor: null,
        addrVillage: null,
        addrMoo: null,
        addrSoi: null,
        addrRoad: null,
        refProvince: null,
        refAmphur: null,
        refTambon: null,
        postCode: null,
        phone: null,
        fax: null,
        locale: null,
    }
}

export const createField = ({ props, data, emit }) => {
    const { viewOnly, dataKey, slots, locale } = props
    const { useForm } = data
    const { modelRef } = useForm
    const model = dataKey ? lodash.get(modelRef, dataKey) : modelRef
    const prefix = dataKey ? `${dataKey}.` : ''
    model.locale = locale
    return putField({
        data, fields: [
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}addrNo`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t('model.address.addrNo'),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.addrNo,
                    'onUpdate:value': value => {
                        model.addrNo = value
                        emit('updateSome', model)
                    },
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}addrMoo`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t('model.address.addrMoo'),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.addrMoo,
                    'onUpdate:value': value => {
                        model.addrMoo = value
                        emit('updateSome', model)
                    },
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}addrSoi`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t('model.address.addrSoi'),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.addrSoi,
                    'onUpdate:value': value => {
                        model.addrSoi = value
                        emit('updateSome', model)
                    },
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}addrRoad`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t('model.address.addrRoad'),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.addrRoad,
                    'onUpdate:value': value => {
                        model.addrRoad = value
                        emit('updateSome', model)
                    },
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}refProvince`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t('model.address.refProvince'),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.refProvince,
                    'onUpdate:value': value => {
                        model.refProvince = value
                        model.refAmphur = null
                        model.refTambon = null
                        model.postCode = null
                        emit('updateSome', model)
                    },
                    disabled: viewOnly,
                    list: ({ searchQuery }) => store.dispatch('resource/v1/master/province/cacheFindAll', { [`name${props.locale}`]: searchQuery }),
                    optLabel: [`name${props.locale}`],
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.name${props.locale}`) }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}refAmphur`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t('model.address.refAmphur'),
                inputProp: ({ field }) => {
                    const defaultDisabled = !model.refProvince || viewOnly
                    return lodash.merge({
                        value: model.refAmphur,
                        'onUpdate:value': value => {
                            model.refAmphur = value
                            model.refTambon = null
                            model.postCode = null
                            emit('updateSome', model)
                        },
                        disabled: defaultDisabled,
                        list: ({ searchQuery }) => store.dispatch('resource/v1/master/amphur/cacheFindAllByProvince', { [`name${props.locale}`]: searchQuery, provinceId: model.refProvince.id }),
                        optLabel: [`name${props.locale}`],
                    }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field, defaultDisabled } }))
                },
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.name${props.locale}`) }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}refTambon`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t('model.address.refTambon'),
                inputProp: ({ field }) => {
                    const defaultDisabled = !model.refAmphur || viewOnly
                    return lodash.merge({
                        value: model.refTambon,
                        'onUpdate:value': value => {
                            model.refTambon = value
                            model.postCode = value ? value.postCode : null
                            emit('updateTambon', value)
                            setTimeout(() => {
                                emit('updateSome', model)
                            }, 100);
                        },
                        disabled: defaultDisabled,
                        list: ({ searchQuery }) => store.dispatch('resource/v1/master/tambon/cacheFindAllByAmphur', { [`name${props.locale}`]: searchQuery, amphurId: model.refAmphur.id }),
                        optLabel: [`name${props.locale}`],
                    }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field, defaultDisabled } }))
                },
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.name${props.locale}`) }
            }),
            ...(slots?.afterTambon?.() || []),
            createFieldInputNumber({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}postCode`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t('model.address.postCode'),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.postCode,
                    'onUpdate:value': value => {
                        model.postCode = value
                        emit('updateSome', model)
                    },
                    disabled: viewOnly,
                    comma: false,
                    maxDecimal: 5,
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}phone`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t('model.address.phone'),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.phone,
                    'onUpdate:value': value => {
                        model.phone = value
                        emit('updateSome', model)
                    },
                    disabled: viewOnly,
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}fax`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t('model.address.fax'),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.fax,
                    'onUpdate:value': value => {
                        model.fax = value
                        emit('updateSome', model)
                    },
                    disabled: viewOnly,
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
        ]
    })
}

export const initForm = ({ props, data, refs, emit }) => {
    data.fields = createField({ props, data, refs, emit });
}

export const copyAddressFull = ({ from, to }) => {
    to.addrNo = from.addrNo
    to.addrRoom = from.addrRoom
    to.addrBuilding = from.addrBuilding
    to.addrFloor = from.addrFloor
    to.addrVillage = from.addrVillage
    to.addrMoo = from.addrMoo
    to.addrSoi = from.addrSoi
    to.addrRoad = from.addrRoad
    copyAddressSome({ from, to })
}

export const copyAddressSome = ({ from, to }) => {
    to.refProvince = from.refProvince
    to.refAmphur = from.refAmphur
    to.refTambon = from.refTambon
    to.postCode = from.postCode
    to.phone = from.phone
    to.fax = from.fax
    from.isSave = true
    to.isSave = true
}